import * as React from "react";
import { SvgIcon } from "@material-ui/core";

export const  SvgRoot = props => {

    const defaultSize = 24;
    const sizeStyle = {
        height: props.size || defaultSize,
        width: props.size || defaultSize
    };

    // tslint:disable
    return (
        <SvgIcon viewBox="0 0 24 24" style={sizeStyle} >
            {props.children}
        </SvgIcon>
    );
};


// WEBPACK FOOTER //
// ./src/components/Icons/SvgRoot.tsx